import { useEffect, useState } from 'react';
import Terms from '../terms/terms';
import { describeAccepted, fetchTermsStatus, type TermsStatus } from '../terms/termsApi';
import { useT } from '../i18n/i18n';

export default function TermsSection() {
  const t = useT();
  const [status, setStatus] = useState<TermsStatus | null>(null);
  const [unreachable, setUnreachable] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void fetchTermsStatus()
      .then((s) => { if (!cancelled) setStatus(s); })
      .catch(() => { if (!cancelled) setUnreachable(true); });
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="card">
      <h2>{t('Terms and what this is')}</h2>
      {!unreachable && (
        <p className="field-hint" style={{ marginTop: 0 }}>
          {status ? describeAccepted(status) : t('Checking…')}
        </p>
      )}
      <Terms />
    </div>
  );
}
